import { buildBucketShares } from "./budgetBucketClassification";
import {
  compareToBenchmark,
  getBenchmarkSet,
  normalizeProductionType,
  type BenchmarkComparison,
  type BenchmarkSet,
  type BenchmarkSource,
} from "./budgetBenchmarks";
import type { BudgetCategory } from "./types";

export function buildBudgetBenchmarkComparison(
  categories: BudgetCategory[],
  contingencyPercentage: number,
  productionType: string | null | undefined,
  benchmarkSet: BenchmarkSet | undefined,
  benchmarkSource: BenchmarkSource
): BenchmarkComparison | null {
  if (!productionType || categories.length === 0) return null;

  const normalizedProductionType = normalizeProductionType(productionType);
  const { shares } = buildBucketShares(categories, contingencyPercentage);
  const resolvedBenchmarkSet =
    benchmarkSet ?? getBenchmarkSet(normalizedProductionType, benchmarkSource);

  return compareToBenchmark(
    shares,
    resolvedBenchmarkSet,
    normalizedProductionType,
    benchmarkSource
  );
}
